import { createI18nInstance as o } from "@systemeio/util";
import e from "../locales/en/common.json.mjs";
const n = {
  en: { common: e }
}, { i18n: t } = o({
  compatibilityJSON: "v3",
  resources: n
});
export {
  t as i18n
};
